import { Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

function ErrorPage({ errorCode, description }) {
  const navigate = useNavigate();
  return (
    <div className="w-50 mt-5 m-auto">
      <Alert variant="danger">
        <div className="page-wrap d-flex flex-row align-items-center">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-12 text-center">
                <span className="display-1 d-block">{errorCode}</span>
                <div className="mb-4 lead">{description}</div>
                <button className="btn btn-link" onClick={() => navigate("/home")}>
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </Alert>
    </div>
  );
}

export default ErrorPage;
